module.exports = __webpack_public_path__ + "static/media/snappyGlass.e8459e63.svg";